import React, { useState } from "react";
import gymimage from "../../../../images/apple.png";
import { Services } from "../../../../api/Services";
import { toast } from "react-toastify";
import InfiniteScroll from "react-infinite-scroll-component";
import { BASE_URL_MEDIA } from "../../../../api/Constants";
import { getImageUrl } from 'components/helpers/Helpers';

// code add By Zohaib

const AssignTrainer = ({ handleCloseAssignTrainer }) => {
  const [page, setPage] = useState(1);
  const [haseMoreDate, setHasMoredata] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedusers, setSelectedusers] = useState([]);
  const [users, setUsers] = useState([]);
  const [userInput, setUserInput] = useState("");
  const [searchPaging, setSearchPaging] = useState(null);

  //Hanlde user input to cahnge trainers in form while seraching
  const handleuserinputChange = async (event) => {
    const newInputValue = event ? event.target.value : "";
    setUserInput(newInputValue);

    try {
      if (newInputValue.trim() === "") {
        setUsers([]);
        setSearchPaging([]);
      } else {
        const result = await Services.getSearch(userInput, 1, "trainer");
        if (result.status === 200) {
          setUsers(result?.data?.data?.listing);
          setSearchPaging(result?.data?.data?.paging);
        } else {
          toast.error(result?.data?.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const loadMore = async () => {
    try {
      if (page + 1 < searchPaging.total_pages + 1) {
        const result = await Services.getSearch(userInput, page + 1, "trainer");
        if (result.status === 200) {
          setUsers([...users, ...result?.data?.data?.listing]);
          setPage(page + 1);
        } else {
          toast.error(result?.data?.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
        }
      } else {
        setHasMoredata(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  //api to add body changes triners list
  const addBodyChangesTrainer = async (users) => {
    setIsLoading(true);
    try {
      let userIds = [...new Set(users.map((item) => item.id))];

      const result = await Services.addBodyChangesTrainer(userIds);

      if (result.status == 200) {
        toast.success(`Trainers Added Successfully`, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.error(`An error occurred while Adding Trainers`, error);
      toast.error(`An error occurred while Adding Trainers`, {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }
    setIsLoading(false);
  };

  const handleSubmit = async () => {
    if (selectedusers.length > 0) {
      await addBodyChangesTrainer(selectedusers);
    }
    handleCloseAssignTrainer();
  };
  // waiting Loader
  const loader = () => {
    return (
      <div class="three-body">
        <div class="three-body__dot"></div>
        <div class="three-body__dot"></div>
        <div class="three-body__dot"></div>
      </div>
    );
  };

  //select user and adding in selected users in form
  const toggleItem = (item) => {
    if (selectedusers.includes(item)) {
      setSelectedusers(
        selectedusers.filter((selectedItem) => selectedItem !== item)
      );
    } else {
      setSelectedusers((prevSelectedUsers) => [...prevSelectedUsers, item]);
    }
  };

  return (
    <div className="excercise-modal trainings-modal mt-4 pt-4">
      <i className="fa fa-times" onClick={handleCloseAssignTrainer}></i>
      <p className="title-small">Add New Triner</p>
      <div className="child-modal ">
        <div className="cont">
          <div className="form-group relative">
            <div className="form-selected-users assign-progress-trainers">
              {Array.isArray(selectedusers) && selectedusers.length > 0 && (
                <ul>
                  {selectedusers.map((suser) => (
                    <li key={suser?.id}>
                      <div className="img">
                        <i
                          className="fa fa-times"
                          onClick={() => toggleItem(suser)}
                        ></i>
                        {suser?.image ? (
                          <img
                            src={getImageUrl(suser?.image, BASE_URL_MEDIA)}
                          />
                        ) : (
                          <img src={gymimage} alt="imgae-girl" />
                        )}
                      </div>
                      <span className="name">{suser?.name}</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <label htmlFor="">Search Trainer</label>
            <input
              type="text"
              value={userInput}
              onChange={async (e) => {
                setPage(1);
                setHasMoredata(true);
                handleuserinputChange(e);
              }}
              placeholder="Search Trainer"
              className="form-control input"
            />
            <div className="form-user-list">
              {Array.isArray(users) && users.length > 0 && (
                <i className="fa fa-times" onClick={() => setUsers([])}></i>
              )}
              {Array.isArray(users) && users.length > 0 && (
                <ul>
                  <InfiniteScroll
                    dataLength={users.length}
                    next={loadMore}
                    hasMore={haseMoreDate}
                    height={100}
                    scrollableTarget="form-user-list"
                  >
                    {users.map((user, index) => (
                      <li
                        key={user?.id}
                        className={
                          selectedusers.includes(user) ? "selected" : ""
                        }
                        onClick={() => toggleItem(user)}
                      >
                        <div className="img">
                          {user?.image ? (
                            <img
                              src={getImageUrl(user?.image, BASE_URL_MEDIA)}
                            />
                          ) : (
                            <img src={gymimage} />
                          )}
                        </div>
                        <span className="name">{user?.name}</span>
                      </li>
                    ))}
                  </InfiniteScroll>
                </ul>
              )}
            </div>
          </div>
        </div>
        {!isLoading ? (
          <div className="d-flex justify-content-between  form-button ">
            <button
              className={`button ${
                selectedusers !== null ? "button-style-form" : ""
              }`}
              onClick={() => handleSubmit()}
            >
              Save
            </button>{" "}
          </div>
        ) : (
          loader()
        )}
      </div>
    </div>
  );
};

export default AssignTrainer;
